$(document).ready(function () {
	let $serviceBooking = $(".booking-container-free");

	$('.rescalendar-free').find('.refDate').on('update', function () {
		Service.updatePrices($serviceBooking);
	});

	$('.form-service-free-booking').submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();
		let $form = $(this);
		let $modal = $form.closest('#modal-online-anatomy-free');
		let $btn = $modal.find('button[type=submit]');
		let btnText = $btn.text();
		let $error = $form.find('.msg-error');

		$error.hide();

		$btn.text('Отправляем...').attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			$btn.text(btnText).removeAttr('disabled');

			if (data.error) {
				$error.text(data.msg).show();
			} else {
				$modal.find('.modal-body-main').slideUp();
				$modal.find('.modal-body-result-success').slideDown();
			}
		});

		return false;
	});

	$(document).on('click', '.booking-container-free .item-slot[data-status="0"] .slot', function () {
		let $modal = $(this).closest('#modal-online-anatomy-free');
		$(this).closest('.booking-container-free').find('.item-slot .slot').removeClass('active');
		$(this).addClass('active');

		let fulldate = $(this).data('fulldate');
		let fulldateString = moment(fulldate).format('DD.MM.YYYY в HH:mm')
		$modal.find('[name=fulldate]').val(fulldate);
		$modal.find('[name=fulldate_string]').val(fulldateString);

		return false;
	});
});
